import React, { useState, useEffect, useRef } from "react";
import { getAnalytics, logEvent } from "firebase/analytics";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";

import bg_screening from "../asset/screening.webp";
import bg_voucher from "../asset/voucher-small.jpg";
import {
  Client_DownloadVoucher,
  useClinicData,
} from "../firebase/useFireEvent";
import html2pdf from "html2pdf.js";
import { updateDoc } from "firebase/firestore";

// import quiz.png as icon_quiz
import { useWindowSize, QuizContainer } from "./useWindowSize";

export default function HomePage() {
  const clinicData = useClinicData();
  const windowSize = useWindowSize();

  const [isHide, setIsHide] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentSerial, setCurrentSerial] = useState(null);

  const [isSuccess, setIsSuccess] = useState(false);
  const [isFail, setIsFail] = useState(false);
  useEffect(() => {
    function onScroll(e) {
      const offset = window.scrollY;
      setIsHide(offset > 30 ? true : false);
    }

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  useEffect(() => {
    const el = document.querySelector("#popup");
    if (showPopup) {
      disableBodyScroll(el);
    } else {
      clearAllBodyScrollLocks();
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [showPopup]);

  if (!clinicData) return null;

  function click_download() {
    setShowPopup(true);
  }

  async function click_confirm() {
    if (isLoading) return;
    setIsLoading(true);

    var element = document.getElementById("element-to-print");

    const res = await Client_DownloadVoucher(selected.name);

    setIsLoading(false);
    if (res) {
      const analytics = getAnalytics();

      console.log("@GA download_voucher", {
        klinik_name: selected.name,
        voucher_serial: res,
      });

      logEvent(analytics, "download_voucher", {
        klinik_name: selected.name,
        voucher_serial: res,
      });

      setIsSuccess(true);
      setCurrentSerial(res);
      html2pdf()
        .set({
          jsPDF: {
            unit: "px",
            format: [1000, 518],
            orientation: "landscape",
          },
        })
        .from(element)
        .save("fys_voucher");
    } else {
      setIsFail(true);
    }
  }

  return (
    <div className="">
      <QuizContainer />
      <div
        className={
          isHide
            ? "fys-header fys-header--shadow fys-header--collapsed"
            : "fys-header shadow-md"
        }
      >
        <div className="fys-header__wrapper fys-content-wrapper fys-content-wrapper--no-padding-v">
          <a
            className="fys-header__skip-to-main fys-button fys-button--primary fys-a11y-visually-hidden fys-a11y-focusable"
            href="#main-content"
          >
            Skip to main content
          </a>
          <a
            className="fys-header__home-link"
            href="https://foryoursweetheart.sg/"
          >
            <span className="fys-a11y-visually-hidden">
              For your sweetheart{" "}
            </span>
            <svg className="fys-header__logo" aria-hidden="true">
              <use xlinkHref="#fys-logo"></use>
            </svg>
          </a>
          <nav className="fys-header__nav" aria-label="Main navigation">
            <ul className="fys-header__list">
              <li className="fys-header__list-item">
                <a href="/video" className="fys-header__nav-link">
                  video
                </a>
              </li>
              <li className="fys-header__list-item">
                <a
                  href="https://connect4yourhealth.com.sg/hf?cid=FysSGTraffic"
                  className="fys-header__nav-link"
                >
                  About heart failure
                </a>
              </li>
              <li className="fys-header__list-item">
                <a
                  href="https://foryoursweetheart.sg/partners"
                  className="fys-header__nav-link"
                >
                  Partners
                </a>
              </li>
              <li className="fys-header__list-item">
                <a
                  href="https://foryoursweetheart.sg/what-can-you-do"
                  className="fys-header__nav-link"
                >
                  What can you do?
                </a>
              </li>
              <li className="fys-header__list-item">
                <a href="/events" className="fys-header__nav-link">
                  Events
                </a>
              </li>
              <li className="fys-header__list-item">
                <a
                  href="https://foryoursweetheart.sg/stories-articles"
                  className="fys-header__nav-link"
                >
                  Stories &amp; articles
                </a>
              </li>
            </ul>
          </nav>
          <input
            type="checkbox"
            id="drawer-toggle"
            className="fys-header__drawer-toggle-input fys-drawer-focusable-items"
            role="button"
            aria-labelledby="drawer-toggle-label"
            aria-pressed="false"
          />
          <label
            htmlFor="drawer-toggle"
            id="drawer-toggle-label"
            className="fys-header__drawer-toggle-label"
            aria-label="Open the navigation menu"
            data-label-open="Open the navigation menu"
            data-label-close="Close the navigation menu"
          >
            <span
              className="fys-header__drawer-toggle-bar"
              aria-hidden="true"
            ></span>
            <span
              className="fys-header__drawer-toggle-bar"
              aria-hidden="true"
            ></span>
            <span
              className="fys-header__drawer-toggle-bar"
              aria-hidden="true"
            ></span>
          </label>
          <div className="fys-header__backdrop" role="presentation"></div>
          <aside
            className="fys-drawer fys-content-wrapper fys-content-wrapper--no-padding-v"
            tabIndex="-1"
            aria-labelledby="drawer-nav"
            aria-hidden="true"
          >
            <nav
              className="fys-drawer__nav"
              id="drawer-nav"
              aria-label="Main navigation"
            >
              <ul className="fys-drawer__list">
                <li className="fys-header__list-item">
                  <a href="/video" className="fys-header__nav-link">
                    video
                  </a>
                </li>
                <li className="fys-drawer__list-item">
                  <a
                    className="fys-drawer__nav-link fys-drawer-focusable-items"
                    href="https://foryoursweetheart.sg/about-the-campaign"
                    tabIndex="-1"
                  >
                    About the campaign
                  </a>
                </li>
                <li className="fys-drawer__list-item">
                  <a
                    className="fys-drawer__nav-link fys-drawer-focusable-items"
                    href="https://foryoursweetheart.sg/partners"
                    tabIndex="-1"
                  >
                    Partners
                  </a>
                </li>
                <li className="fys-drawer__list-item">
                  <a
                    href="https://foryoursweetheart.sg/what-can-you-do"
                    className="fys-drawer__nav-link fys-drawer-focusable-items"
                    tabIndex="-1"
                  >
                    What can you do?
                  </a>
                </li>
                <li className="fys-drawer__list-item">
                  <a
                    className="fys-drawer__nav-link fys-drawer-focusable-items"
                    href="/events"
                    tabIndex="-1"
                  >
                    Events
                  </a>
                </li>
                <li className="fys-drawer__list-item">
                  <a
                    className="fys-drawer__nav-link fys-drawer-focusable-items"
                    href="https://foryoursweetheart.sg/stories-articles"
                    tabIndex="-1"
                  >
                    Stories &amp; articles
                  </a>
                </li>
              </ul>
            </nav>
          </aside>
        </div>
      </div>

      {showPopup && (
        <div
          id="popup"
          className="fixed z-50 w-screen h-screen"
          style={{ backgroundColor: "rgba(0 0 0 /30%)" }}
        >
          <div
            className="bg-red-ci text-white text-xs rounded-lg absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-11/12 md:w-96"
            style={{ padding: "1rem 1.2rem" }}
          >
            {!isSuccess && !isFail && (
              <div
                className="absolute top-3 right-3 w-6 h-6 rflex items-center cursor-pointer hover:opacity-50"
                onClick={() => {
                  setShowPopup(false);
                }}
              >
                <svg className="w-full h-full" style={{ color: "white" }}>
                  <use xlinkHref="#close-btn" style={{ color: "white" }}></use>
                </svg>
              </div>
            )}

            {/* <!-- cover_text --> */}
            {!isSuccess && !isFail && (
              <div id="cover_text">
                <h2 style={{ fontSize: "1.2rem" }}>
                  <strong>Diabetes Risk Factors</strong>
                </h2>

                <ul className="list-disc pl-5 my-3">
                  <li>People over 40 years old</li>
                  <li>Have a family history of diabetes</li>
                  <li>Overweight</li>
                  <li>Have high blood pressure</li>
                  <li>Inactive lifestyle</li>
                  <li>Have abnormal blood cholesterol/lipid levels</li>
                </ul>

                <p className="font-bold">Disclaimer:</p>
                <div className="flex flex-col space-y-2 mt-2">
                  <p className="">
                    1.This is for informational purposes only and it is not
                    meant to be a substitute for professional medical advice,
                    diagnosis or treatment. Kindly consult with a doctor or
                    other health care professional for medical advice or
                    information about diagnosis and treatment.
                    <br />
                  </p>
                  <p>
                    2.This Free Diabetes Screening Voucher offers free HbA1c
                    test only and does not include doctor’s consultation fee or
                    medication.
                  </p>
                  <p>
                    <strong>3. WHILE STOCKS LAST.</strong>
                  </p>
                </div>

                <div
                  onClick={click_confirm}
                  className="mt-5 bg-white rounded-md text-black font-bold py-3 text-center cursor-pointer"
                >
                  <p>
                    {isLoading ? "Loading" : "Acknowledge & Download Voucher"}
                  </p>
                </div>
              </div>
            )}

            {isSuccess && (
              <div className="text-sm" style={{ lineHeight: "1rem" }}>
                <h2 style={{ fontSize: "1.2rem" }}>
                  <strong>Yessss! Your download has been successful!</strong>
                </h2>
                <p className="font-bold mt-5  mb-2">
                  Scheduled appointment is required prior to visit.
                </p>
                <p>Remember to present your voucher on your redemption.</p>
                <a href="https://foryoursweetheart.sg/">
                  <div className="mt-5  bg-white rounded-md text-black font-bold py-3 text-center cursor-pointer">
                    <p>Back to Home</p>
                  </div>
                </a>
              </div>
            )}

            {isFail && (
              <div className="text-sm" style={{ lineHeight: "1rem" }}>
                <h2 style={{ fontSize: "1.2rem" }}>
                  <strong>Out Of Stock!</strong>
                </h2>
                <p className="font-bold mt-5  mb-2">
                  Sorry to inform that the voucher is temporarily out of stock
                  due to overwhelming demand.
                </p>
                <p>You may choose others available outlets.</p>
                <div
                  onClick={() => {
                    setIsFail(false);
                    setShowPopup(false);
                  }}
                  className="mt-5 bg-white rounded-md text-black font-bold py-3 text-center cursor-pointer"
                >
                  <p>Okay</p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ======== BODY =========== */}
      <div className="CONTENT flex flex-col items-center px-3">
        <div className="WRAPPER text-gray-500" style={{ maxWidth: "1200px" }}>
          <img
            className="object-contain w-full"
            style={{ maxWidth: "1200px", paddingTop: "8rem" }}
            src={bg_screening}
            alt=""
          />
          <p className="mt-8">
            <p>Keeping Yourself & Your Loved Ones Healthy</p>
            <p>
              Get your FREE screening for Diabetes at any of our participating
              clinics or outlets now.
            </p>
          </p>
          {/* <section className="SCROLLTO mt-8">
            <p className="text-gray-700 font-bold text-xl uppercase">
              scroll to
            </p>
            <div className="flex flex-wrap mt-3 text-sm text-white">
              {["north", "south", "east", "west"].map((x) => {
                return (
                  <div
                    key={x}
                    className="bg-red-600 capitalize text-white rounded-md cursor-pointer transform transition hover:scale-105"
                    style={{
                      padding:
                        windowSize.width < 500 ? ".3rem 1.4rem " : ".3rem 2rem",
                      marginRight: "8px",
                      marginTop: "3px",
                    }}
                  >
                    {x}
                  </div>
                );
              })}
            </div>
          </section> */}

          <section className="LIST my-10 ">
            <div className="NORTH">
              <p className="uppercase text-gray-700 font-bold text-xl">
                clinic list
              </p>
              <hr className="mt-5 mb-8" />
              <div className="space-y-8">
                {/* ===== ITEM ===== */}

                {clinicData.map((clinic, i) => {
                  return (
                    <div
                      key={i}
                      className="flex flex-col md:flex-row items-stretch shadow"
                    >
                      <div
                        className="WRAPPER relative overflow-hidden bg-gray-100"
                        style={
                          windowSize.width < 768
                            ? { paddingTop: "60%" }
                            : { paddingLeft: "40%" }
                        }
                      >
                        {/* <iframe
                          className="absolute top-0 left-0 w-full h-full"
                          src="https://drive.google.com/file/d/1yRHLSVLO_a2M4vq4wofXfdbj_TT5uT-T/preview"
                          allow="autoplay"
                        ></iframe> */}
                        {/* <div
                          className="absolute top-0 left-0 w-full h-full"
                          style={{
                            backgroundImage: `url('https://drive.google.com/u/1/uc?id=${clinic.image
                              .match(/d\/(.*)(?=\/)/g)[0]
                              .substring(2)}')`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }}
                        ></div> */}
                        <div
                          className="absolute top-0 left-0 w-full h-full"
                          style={{
                            backgroundImage: `url("${clinic.image}")`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }}
                        ></div>
                      </div>

                      <div className="details flex-1 border md:border-l-0 px-4 md:px-7 pt-4 pb-6 text-blue-ci text-sm">
                        <p className="text-xl uppercase font-bold text-blue-ci">
                          {clinic.name}
                        </p>
                        <p className="mt-2">{clinic.address}</p>
                        <p className="mt-6  mb-8">
                          <span className="font-bold">Contact number:</span>{" "}
                          {clinic.phone}
                        </p>
                        <a target="_blank" href={clinic["map"]}>
                          <div className="bg-blue-ci  text-white w-full md:w-40 text-center py-2 rounded-md cursor-pointer">
                            Directions
                          </div>
                        </a>

                        {clinic.download >= +clinic.voucher ? (
                          <div className="bg-red-ci font-bold text-white w-full md:w-40 text-center py-2 rounded-md mt-1.5   opacity-50">
                            Out of Stock
                          </div>
                        ) : (
                          <div
                            onClick={() => {
                              setSelected(clinic);
                              click_download();
                            }}
                            className="bg-blue-ci text-white w-full md:w-40 text-center py-2 rounded-md mt-1.5  cursor-pointer"
                          >
                            Download Voucher
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* ======== FOOTER =========== */}
      <footer className="fys-footer fys-drawer-external-tree-roots">
        <div className="fys-footer__wrapper fys-content-wrapper">
          <a
            href="https://www.boehringer-ingelheim.com/"
            className="fys-footer__logo-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="fys-a11y-visually-hidden">
              {" "}
              Boehringer Ingelheim{" "}
            </span>
            <svg className="fys-footer__logo" aria-hidden="true">
              <use xlinkHref="#boehringer-ingelheim"></use>
            </svg>
          </a>
          <div className="fys-footer__content-col">
            <nav className="fys-footer__nav">
              <ul className="fys-footer__list">
                <li className="fys-footer__list-item">
                  <a
                    className="fys-footer__nav-link"
                    href="https://foryoursweetheart.sg/about-the-campaign"
                  >
                    About the campaign{" "}
                  </a>
                </li>
                <li className="fys-footer__list-item">
                  <a
                    className="fys-footer__nav-link"
                    href="https://foryoursweetheart.sg/partners"
                  >
                    Partners{" "}
                  </a>
                </li>
                <li className="fys-footer__list-item">
                  <a
                    className="fys-footer__nav-link"
                    href="https://foryoursweetheart.sg/what-can-you-do"
                  >
                    What can you do?{" "}
                  </a>
                </li>
                <li className="fys-footer__list-item">
                  <a className="fys-footer__nav-link" href="/events">
                    Events{" "}
                  </a>
                </li>
                <li className="fys-footer__list-item">
                  <a
                    className="fys-footer__nav-link"
                    href="https://foryoursweetheart.sg/stories-articles"
                  >
                    Stories &amp; articles{" "}
                  </a>
                </li>
              </ul>
            </nav>
            <div className="fys-markdown-text fys-footer__content">
              <p>
                Copyright © 2019 Boehringer Ingelheim Singapore Pte. Ltd. All
                rights reserved. <br /> Use of this Site is subject to the{" "}
                <a href="https://foryoursweetheart.sg/terms-of-use">
                  Terms of Use
                </a>{" "}
                and{" "}
                <a href="https://foryoursweetheart.sg/data-privacy-statement">
                  Privacy Policy
                </a>
                . MPR-SG-100043 August&nbsp;2019.
              </p>
              <p>
                This Website is intended for persons in Singapore. The contents
                of this Website are for information purposes only and are not
                intended to substitute for advice, treatment or recommendations
                of a healthcare professional. For your health concerns and other
                questions about symptoms, treatment or medication, consult a
                healthcare&nbsp;professional.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* ======== SVG DATA =========== */}
      <svg aria-hidden="true" className="hidden">
        <symbol
          viewBox="0 0 490.4 268.8"
          id="fys-logo"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#0E5AA0"
            d="M16.7 102.7a8.9 8.9 0 003 3.7c1.3 1 3.2 2 5.7 3 2.4.9 5.6 1.7 9.4 2.5a41 41 0 0117.2 7.2c3.7 3 5.5 7.3 5.5 12.7a18.7 18.7 0 01-14 18.4 41.8 41.8 0 01-24.8-1.3 42.5 42.5 0 01-13.3-8.4l4.9-5.7a41 41 0 0011 7.4c3.7 1.6 8 2.4 12.9 2.4a18 18 0 0011.3-3.3c2.8-2.2 4.2-5 4.2-8.6 0-1.7-.3-3.2-.8-4.5a9 9 0 00-2.8-3.5c-1.3-1-3.2-2-5.6-3-2.3-.8-5.3-1.6-9-2.4-4-.9-7.5-1.9-10.4-3-3-1.1-5.4-2.5-7.3-4a15 15 0 01-4.3-5.7 17 17 0 01-1.4-7.5 17.3 17.3 0 016.4-13.8c2-1.7 4.5-3 7.3-4S27.6 80 31 80c5 0 9.5.7 13.4 2.1 3.8 1.4 7.5 3.5 11 6.4l-4.5 6a30 30 0 00-20.1-7.6c-2.3 0-4.3.4-6.2 1-1.8.6-3.3 1.4-4.6 2.4a10.3 10.3 0 00-4 8c0 1.7.2 3.2.7 4.5zm96.9 37.7L127 99.1h8L117 151h-6.7l-13.8-40.6-14 40.6h-6.8l-18-51.9H66l13.5 41.3L93.3 99h6.3l14 41.5zm31.2-5.3a17.9 17.9 0 009.6 8.9c2 .7 4.2 1.1 6.5 1.1 3.6 0 6.7-.6 9.2-2 2.6-1.3 5-3 7-5.2l4.8 4.2a26.2 26.2 0 01-21.2 9.7 25.7 25.7 0 01-18.1-7.4 28.3 28.3 0 01-7.6-19.5c0-3.7.5-7.2 1.8-10.5a24 24 0 0133-14.2c3 1.4 5.5 3.3 7.5 5.8s3.6 5.3 4.7 8.7c1 3.3 1.6 6.8 1.6 10.6v1.1l-.1 1.3h-40.7c.2 2.8 1 5.3 2 7.4zm31-13c-.3-2.4-.7-4.6-1.5-6.7a17 17 0 00-3.2-5.6 15.1 15.1 0 00-11.7-5.3 14.4 14.4 0 00-11.2 5 19.4 19.4 0 00-3.6 5.6 19 19 0 00-1.8 7h33zm21.4 13a17.9 17.9 0 009.6 8.9c2 .7 4.2 1.1 6.5 1.1a19 19 0 009.2-2 25 25 0 007-5.2l4.8 4.2a26.2 26.2 0 01-21.2 9.7 25.7 25.7 0 01-18.2-7.4 28.3 28.3 0 01-7.6-19.5 28.6 28.6 0 017-19.1 24 24 0 0127.9-5.6c3 1.4 5.5 3.3 7.5 5.8s3.6 5.3 4.7 8.7c1 3.3 1.6 6.8 1.6 10.6v1.1l-.1 1.3h-40.7c.2 2.8.9 5.3 2 7.4zm31-13c-.3-2.4-.7-4.6-1.5-6.7a17 17 0 00-3.2-5.6 15.1 15.1 0 00-11.7-5.3 14.4 14.4 0 00-11.2 5 19.4 19.4 0 00-3.6 5.6 19 19 0 00-1.8 7h33zm23.3 13.9c0 3.1.8 5.4 2.4 6.6a9.8 9.8 0 006.3 2 16.7 16.7 0 007.4-1.9v6.6c-1.3.7-2.7 1.3-4.2 1.6s-3.2.6-5 .6c-2 0-4-.3-5.8-.8a12 12 0 01-4.6-2.5 11.7 11.7 0 01-3-4.6c-.8-1.8-1.2-4-1.2-6.6v-31.1h-7.1v-6.8h7.1V83.6h7.7V99h16.3v6.8h-16.3v30z"
          ></path>
          <path
            fill="#E9292F"
            d="M280.3 150.6h-7.6V77.9h7.6v30.2c1.8-2.8 4-5.2 6.8-7.1 2.8-2 6.4-3 10.9-3 3 0 5.9.5 8.3 1.5a17.2 17.2 0 0110 10.8c1 2.5 1.4 5.3 1.4 8.3v32H310v-30c0-4.8-1.2-8.6-3.7-11.4-2.4-2.8-6-4.2-10.5-4.2a17 17 0 00-6.1 1.1 14.3 14.3 0 00-8.2 8.5c-.8 2-1.2 4.1-1.2 6.5v29.5zm156 0h-7.7V99.1h7.7v13.5a27.4 27.4 0 018.2-10.5 20.3 20.3 0 0112.8-3.9v8.3h-.6c-2.8 0-5.5.5-8 1.5s-4.6 2.5-6.5 4.5c-1.8 2-3.3 4.4-4.4 7.4a30 30 0 00-1.5 10.2v20.5zM474 136c0 3.1.9 5.4 2.5 6.6a9.8 9.8 0 006.3 2 16.7 16.7 0 007.4-1.9v6.6c-1.3.7-2.7 1.3-4.2 1.6s-3.2.6-5 .6c-2.1 0-4-.3-5.8-.8-1.8-.5-3.4-1.4-4.6-2.5a11.7 11.7 0 01-3-4.6c-.8-1.8-1.2-4-1.2-6.6v-31.1h-7.1v-6.8h7.1V83.6h7.7V99h16.3v6.8h-16.3v30z"
          ></path>
          <path
            fill="#414142"
            d="M84.3 50.9h-20v11.7h17.9V66H64.4v14.3h-3.7V47.5h23.6v3.4zM110 73a12.8 12.8 0 01-6.8 6.9c-1.5.7-3.2 1-5 1A12.4 12.4 0 0186.5 73a13 13 0 012.6-13.9 12.5 12.5 0 019.2-3.7A12.5 12.5 0 01109.9 73zm-3.5-8.5a9.3 9.3 0 00-4.8-5 8.8 8.8 0 00-7.2 0 8 8 0 00-2.7 2 9.6 9.6 0 00-2.5 6.6 10 10 0 002.5 6.7 9 9 0 006.5 2.8 8.8 8.8 0 006.4-2.7 10.2 10.2 0 001.8-10.4zM118 80.3h-3.6V56h3.7v6.4a13 13 0 013.9-5 9.6 9.6 0 016-1.8v4h-.3a10 10 0 00-3.7.6 8.5 8.5 0 00-3.1 2.1 10 10 0 00-2 3.5c-.6 1.4-.8 3-.8 4.9v9.6zm39.5 0h-3.7v-13L140 47.5h4.5l11 16.4 11.2-16.4h4.3l-13.6 19.8v13zm34.4-7.3a12.8 12.8 0 01-6.7 6.9 12 12 0 01-5 1 12.4 12.4 0 01-11.7-7.8 13 13 0 012.6-13.9 12.5 12.5 0 019.1-3.7A12.5 12.5 0 01192 73.1zm-3.4-8.5a9.3 9.3 0 00-4.8-5 8.8 8.8 0 00-7.2 0 8 8 0 00-2.8 2 9.6 9.6 0 00-2.4 6.6 10 10 0 002.5 6.7 9 9 0 006.4 2.8 8.8 8.8 0 006.5-2.7c.7-.9 1.4-1.8 1.8-3a10.2 10.2 0 000-7.4zm25.3-8.5h3.5v24.3h-3.5v-4.2c-.9 1.3-2 2.4-3.2 3.4-1.3.9-3 1.3-5.1 1.3-1.5 0-2.8-.2-4-.7s-2-1-2.9-2a8.8 8.8 0 01-1.8-3c-.4-1.2-.6-2.5-.6-4v-15h3.6v14.1c0 2.3.5 4 1.7 5.4 1.2 1.3 2.8 2 5 2 1 0 2-.2 2.9-.6.9-.3 1.6-.9 2.3-1.5a8.3 8.3 0 002-5.5V56zM226 80.3h-3.6V56h3.7v6.4a13 13 0 013.9-5 9.6 9.6 0 016-1.8v4h-.3a10 10 0 00-3.7.6 8.5 8.5 0 00-3.1 2.1 10 10 0 00-2 3.5c-.6 1.4-.8 3-.8 4.9v9.6zm209.6 121.3l-3-1.9 1.5-2 7-11.5a13 13 0 00-1.1-15.3l-8.4-9.9a13.1 13.1 0 00-16.1-3.1c0-1-.2-2-.5-3-.9-3-3.2-5.3-7-7.2-5.7-3-10.8-2.7-14.7.6l-10-19.6 9.8-11.3a13 13 0 00-1.9-18.4 13 13 0 00-17.5 1l-3.4 3.2c-1.6-2.3-3.3-4.8-7.5-6-3.6-1-6.8-1-10.5.8a14.7 14.7 0 00-6.8 19.8l4.5 9.3-8.2 10.2v.1a85 85 0 00-2.5 4.7l-4.7 16.7-.2.7c-2.6 12-6.6 23.8-9.2 35.8a36.3 36.3 0 0017.5 35.2l56 33.2a36.2 36.2 0 0053.5-40c-.4-1.5-1.3-13.1-16.6-22.1zm-45.1-50.1l-.3.4-1.6 2.6-.1-.4a13 13 0 00-6.8-8 14 14 0 00-13.2 0l12.2-14 9.8 19.4zm-42-43.7c1-2.7 2.9-5 5.5-6.2 2.8-1.4 5.8-1.3 8.5-.3 2.2.8 4 2.3 5.2 4.4l-15 18-3.7-7.6a10.8 10.8 0 01-.5-8.3zm96.4 141.3a32.3 32.3 0 01-44.2 11.3l-56-33.3a32.4 32.4 0 01-14.7-35.9v-.5c0-1 13.1-47.6 13.1-47.6.4-1.2 1-2.3 1.7-3.3l31-36.4a9.1 9.1 0 0113-1.4 9.1 9.1 0 011.2 13l-27.3 32-5.8 14-17.7 27.6a13 13 0 004 18l2-3.2a9.2 9.2 0 01-2.7-12.7l17.5-27.1h.1l.3-.8 6.7-10.3c2.7-4.2 8-5.5 12.8-3a9 9 0 014.8 5.5c.7 2.5.1 5.4-1.5 7.8l-18.5 29.7a13 13 0 004.2 18l2-3.3a9 9 0 01-2.9-12.7l25.5-40.6c3-4.7 7.1-5.7 12.8-2.8 2.8 1.4 4.4 3 5 4.8.5 1.8.3 4-.9 6.7l-21 35.2a13 13 0 004.4 18l2-3.4a9.1 9.1 0 01-3.1-12.6s20.7-34.3 21.1-35.3a9.2 9.2 0 0114.8-1l8.4 9.9c2.5 3 2.9 7.3.8 10.7l-7 11.4a9.1 9.1 0 01-11.7 3.5l10.3-16.5-3.3-2-12.3 19.7 1.4 1 1 .7a13 13 0 0013 .3l4.4 2.6a32 32 0 0111.3 44.2z"
          ></path>
          <path
            fill="none"
            d="M445 249.1a32.3 32.3 0 01-44.3 11.3l-56-33.3a32.4 32.4 0 01-14.7-35.9v-.5c0-1 13.1-47.6 13.1-47.6.4-1.2 1-2.3 1.7-3.3l31-36.4a9.1 9.1 0 0113-1.4 9.1 9.1 0 011.2 13l-27.3 32-5.8 14-17.7 27.6a13 13 0 004 18l2-3.2a9.2 9.2 0 01-2.7-12.7l17.5-27.1h.1l.3-.8 6.7-10.3c2.7-4.2 8-5.5 12.8-3a9 9 0 014.8 5.5c.7 2.5.1 5.4-1.5 7.8l-18.5 29.7a13 13 0 004.2 18l2-3.3a9 9 0 01-2.9-12.7l25.5-40.6c3-4.7 7.1-5.7 12.8-2.8 2.8 1.4 4.4 3 5 4.8.5 1.8.3 4-.9 6.7l-21 35.2a13 13 0 004.4 18l2-3.4a9.1 9.1 0 01-3.1-12.6s20.7-34.3 21.1-35.3a9.2 9.2 0 0114.8-1l8.4 9.9c2.5 3 2.9 7.3.8 10.7l-7 11.4a9.1 9.1 0 01-11.7 3.5l10.3-16.5-3.3-2-12.3 19.7 1.4 1 1 .7a13 13 0 0013 .3l4.4 2.6a32 32 0 0111.3 44.2z"
          ></path>
          <path
            fill="none"
            d="M390.5 151.5l-.3.4-1.6 2.6-.1-.4a13 13 0 00-6.8-8 14 14 0 00-13.2 0l12.2-14 9.8 19.4zm-42-43.7c1-2.7 2.9-5 5.5-6.2 2.8-1.4 5.8-1.3 8.5-.3 2.2.8 4 2.3 5.2 4.4l-15 18-3.7-7.6a10.8 10.8 0 01-.5-8.3z"
          ></path>
          <path
            fill="#E9292F"
            d="M420.2 88.8A48 48 0 00408 58.1C378.7 21.6 370.7 0 370.7 0s-8.1 21.6-37.4 58a48.2 48.2 0 00-12.1 33.3v.3c-.5 7.8 3 16.2 7.8 23.6 1.8 2.6 4 5.3 6.6 8a31.6 31.6 0 01-5.2-18.5 22 22 0 018.2-16.3 23.8 23.8 0 0130.9.6c4.5-3.8 10.1-6 15.7-6 5.5 0 10.6 1.9 15.1 5.4a22 22 0 018.2 16.3c.4 6.3-1.6 13-5.5 19-2 3-4.8 6-8 9.1a84.3 84.3 0 0017.3-17.6 40.7 40.7 0 007.8-23.6v-2.8z"
          ></path>
          <ellipse
            cx="357.1"
            cy="107.6"
            fill="#E9292F"
            rx="3.3"
            ry="3.2"
          ></ellipse>
          <path fill="none" d="M5.1 191.8h316v54.5H5.1z"></path>
          <path
            fill="#414142"
            d="M18.7 192.5h1.7l5 15.2 5.2-15.2h2.1L26.2 211h-1.7l-5-14.8-5 14.8h-1.7l-6.5-18.4h2.2l5.2 15.2 5-15.2zm21.8 18.2h-2v-19h2v8c.4-.8 1-1.4 1.7-2a6.2 6.2 0 015.1-.3 4.5 4.5 0 012.6 2.8c.2.7.3 1.4.3 2.2v8.3h-2V203c0-1.3-.3-2.2-1-3-.6-.7-1.5-1-2.7-1-.6 0-1.1 0-1.6.2a3.7 3.7 0 00-2.1 2.2c-.2.5-.3 1.1-.3 1.7v7.7zm18.3-4a4.7 4.7 0 002.5 2.3 5.7 5.7 0 004.1-.2c.7-.4 1.3-.8 1.8-1.4l1.3 1.1c-.7.8-1.5 1.4-2.3 1.9s-2 .7-3.3.7a6.7 6.7 0 01-4.7-2 6.8 6.8 0 01-1.5-2.2c-.3-.9-.5-1.8-.5-2.9 0-1 .2-1.9.5-2.7a6.2 6.2 0 0110.6-2.2c.5.6 1 1.4 1.2 2.3.3.8.4 1.7.4 2.7v.7H58.2c.1.7.3 1.3.6 1.9zm8-3.4l-.3-1.8a4.2 4.2 0 00-2.1-2.4 4 4 0 00-1.8-.4 3 3 0 00-1.6.4c-.5.2-1 .5-1.4 1l-.9 1.4-.5 1.8H67zm10.2 7.4h-2v-13.4h2v3.5a7.2 7.2 0 012.1-2.7 5.3 5.3 0 013.3-1v2.1h-.1c-.7 0-1.4.2-2 .4s-1.3.7-1.8 1.2-.8 1.1-1.1 2c-.3.7-.4 1.6-.4 2.6v5.3zm12.3-4a4.7 4.7 0 002.5 2.3 5.7 5.7 0 004.1-.2c.6-.4 1.3-.8 1.8-1.4l1.3 1.1c-.7.8-1.5 1.4-2.4 1.9s-1.9.7-3.2.7a6.7 6.7 0 01-4.7-2 6.8 6.8 0 01-1.5-2.2c-.3-.9-.5-1.8-.5-2.9 0-1 .1-1.9.5-2.7a6.2 6.2 0 0110.6-2.2c.5.6 1 1.4 1.2 2.3.3.8.4 1.7.4 2.7v.7H88.7c.1.7.3 1.3.6 1.9zm8-3.4l-.3-1.8a4.2 4.2 0 00-2.1-2.4 4 4 0 00-1.8-.4 3 3 0 00-1.6.4c-.5.2-1 .5-1.4 1l-.9 1.4-.5 1.8h8.6z"
          ></path>
          <path
            fill="#0E5AA0"
            d="M126.7 210.7V208l-1 1.2-1 1-1.4.6-1.7.2a6.2 6.2 0 01-4.5-1.8 7.6 7.6 0 01-2-5.2c0-1 .2-2 .6-3a6.7 6.7 0 013.5-3.5 6 6 0 017.5 2.4v-8.1h2v19h-2zm-.3-8.8a5 5 0 00-4.5-3c-.6 0-1.3 0-1.8.3s-1.1.6-1.5 1-.8 1-1 1.6a6 6 0 00-.4 2.2c0 .8.1 1.5.4 2.2a5 5 0 001 1.6 4.4 4.4 0 003.3 1.4c.6 0 1.2-.1 1.8-.4l1.6-1c.4-.5.8-1 1-1.7.3-.6.5-1.3.5-2 0-.9-.2-1.6-.4-2.2zm9.2-7.5v-2.2h2.2v2.2h-2.2zm0 16.3v-13.4h2v13.4h-2zm11.7-11.5c-.6.1-1.3.4-1.9.7l-.6-1.7 2.3-.8c.7-.2 1.6-.3 2.6-.3 1.8 0 3.3.5 4.2 1.4 1 .9 1.5 2.2 1.5 4v8.2h-1.9v-2c-.5.6-1 1.2-1.9 1.6a6.9 6.9 0 01-4.8.5 5 5 0 01-1.6-.8 3.8 3.8 0 01-1.6-3.2c0-.7.2-1.3.4-1.9.3-.5.7-1 1.2-1.3a7.3 7.3 0 014.2-1.2 14.3 14.3 0 014.1.6v-.5c0-1.2-.3-2-1-2.7-.7-.6-1.7-1-3-1a8 8 0 00-2.2.4zm-.6 5.5c-.7.5-1 1.2-1 2 0 .5 0 .9.3 1.2.1.3.4.6.7.8.3.3.7.4 1 .6l1.3.1c.7 0 1.3 0 1.8-.2l1.4-.8 1-1.1.3-1.5v-1.3a21 21 0 00-4-.6c-1.2 0-2.1.3-2.8.8zm28.5 2.3a6.3 6.3 0 01-7.6 3.8 5.7 5.7 0 01-2.5-1.5 8 8 0 01-.9-1.1v2.5h-2v-19h2v8.3l1-1.1 1-1 1.4-.6c.6-.2 1.1-.3 1.8-.3a6.2 6.2 0 014.4 1.8 7.6 7.6 0 012 5.2c0 1.1-.2 2.1-.6 3zm-1.9-5.1a5 5 0 00-1-1.7 4.4 4.4 0 00-3.3-1.4c-.6 0-1.2.2-1.8.4a5.1 5.1 0 00-2.7 2.7c-.2.6-.4 1.3-.4 2.1s.2 1.5.4 2.1a4.9 4.9 0 006.3 2.8c.6-.3 1.1-.6 1.5-1 .5-.5.8-1 1-1.7a6 6 0 00.4-2.2c0-.8-.1-1.5-.4-2.1zm10.4 4.8a4.7 4.7 0 002.5 2.3 5.4 5.4 0 004.1-.2c.7-.4 1.3-.8 1.9-1.4l1.2 1.1a6.6 6.6 0 01-5.5 2.6 6.7 6.7 0 01-4.8-2 6.8 6.8 0 01-1.4-2.2 7.8 7.8 0 010-5.6c.2-.9.7-1.6 1.2-2.2a6.2 6.2 0 019.3 0c.5.6 1 1.4 1.2 2.3.3.8.4 1.7.4 2.7v.7h-10.6c0 .7.2 1.3.5 1.9zm8-3.4c0-.6 0-1.2-.3-1.8l-.8-1.4a4 4 0 00-3-1.4 3 3 0 00-1.7.4c-.5.2-1 .5-1.3 1l-1 1.4-.4 1.8h8.6zm10.5 3.7c0 .8.2 1.3.6 1.7s1 .5 1.7.5a4.3 4.3 0 002-.5v1.7l-1.2.4a5.5 5.5 0 01-2.8 0 3 3 0 01-2-1.8c-.2-.6-.3-1.1-.3-1.8V199h-1.9v-1.8h2v-4h2v4h4.2v1.8h-4.3v7.8zm11.3-.3a4.7 4.7 0 002.6 2.3 5.2 5.2 0 004.1-.2 11 11 0 001.8-1.4l1.2 1.1a6.6 6.6 0 01-5.5 2.6 6.7 6.7 0 01-4.7-2 6.8 6.8 0 01-1.5-2.2c-.4-.9-.5-1.8-.5-2.9a6.9 6.9 0 011.8-5 6.2 6.2 0 019.2 0 7 7 0 011.3 2.4c.2.8.4 1.7.4 2.7v.7H213c0 .7.3 1.3.5 1.9zm8.1-3.4c0-.6-.2-1.2-.4-1.8a4.2 4.2 0 00-2-2.4 4 4 0 00-1.8-.4c-.6 0-1.2.1-1.7.4-.5.2-1 .5-1.3 1l-1 1.4-.4 1.8h8.6zm16.9 5.4a4 4 0 01-1 1.2c-.4.4-1 .6-1.5.8a6 6 0 01-2 .3 9.1 9.1 0 01-5.6-2l1.1-1.4c.8.5 1.5 1 2.3 1.3.8.3 1.6.4 2.4.4.8 0 1.5-.2 2-.6.5-.3.8-.9.8-1.5 0-.4-.1-.7-.3-1l-.7-.6a24.8 24.8 0 00-4-1.4c-.5-.1-1-.4-1.4-.6a3 3 0 01-1.4-2.6 3.6 3.6 0 011.3-2.9l1.4-.8a6 6 0 011.8-.2 9.5 9.5 0 014.8 1.5l-.8 1.5a9 9 0 00-2-1 7 7 0 00-2-.3 3 3 0 00-1.9.5c-.5.4-.7.8-.7 1.4 0 .4 0 .6.3.9l.8.6 1 .5 1.4.4 1.5.5 1.4.7 1 1c.2.5.4 1 .4 1.6 0 .7-.2 1.3-.4 1.8z"
          ></path>
          <path
            fill="#414142"
            d="M258.3 199.2c-.7.1-1.3.4-2 .7l-.5-1.7 2.2-.8a10 10 0 012.7-.3c1.8 0 3.2.5 4.2 1.4s1.5 2.2 1.5 4v8.2h-2v-2c-.4.6-1 1.2-1.8 1.6a6.6 6.6 0 01-4.8.5l-1.7-.8c-.5-.3-.8-.8-1.1-1.3-.3-.6-.4-1.2-.4-1.9s.1-1.3.4-1.9c.3-.5.7-1 1.2-1.3.5-.4 1-.7 1.8-.9.7-.2 1.5-.3 2.3-.3a14.3 14.3 0 014.2.6v-.5c0-1.2-.4-2-1.1-2.7s-1.7-1-3-1a8 8 0 00-2.1.4zm-.7 5.5c-.6.5-1 1.2-1 2 0 .5.1.9.3 1.2l.7.8c.3.3.7.4 1.1.6l1.3.1c.6 0 1.2 0 1.7-.2.6-.2 1-.5 1.5-.8l1-1.1.3-1.5v-1.3a20.9 20.9 0 00-4-.6 5 5 0 00-2.9.8zm17.6 6h-2v-13.4h2v2.3c.4-.7 1-1.3 1.7-1.8s1.7-.8 2.9-.8c.8 0 1.5.1 2.1.4a4.6 4.6 0 012.6 2.8c.3.7.4 1.4.4 2.2v8.3h-2V203c0-1.3-.3-2.2-1-3-.6-.7-1.5-1-2.7-1-.6 0-1.1 0-1.6.2a3.7 3.7 0 00-2.1 2.2c-.2.5-.3 1.1-.3 1.7v7.7zm27.3 0V208l-1 1.2-1 1-1.5.6-1.7.2a6.2 6.2 0 01-4.4-1.8c-.6-.6-1-1.3-1.5-2.2a9.4 9.4 0 010-6 6.7 6.7 0 013.6-3.5 6 6 0 017.5 2.4v-8.1h2v19h-2zm-.4-8.8a5 5 0 00-4.4-3 4.3 4.3 0 00-3.3 1.4c-.5.3-.8.9-1 1.5s-.5 1.4-.5 2.2c0 .8.2 1.5.4 2.2a5 5 0 001 1.6 4.4 4.4 0 003.4 1.4c.6 0 1.2-.1 1.8-.4l1.5-1c.5-.5.9-1 1.1-1.7.3-.6.4-1.3.4-2 0-.9 0-1.6-.4-2.2z"
          ></path>
          <path
            fill="#E9292F"
            d="M9.3 242h-2v-19h2v7.8c.5-.7 1-1.3 1.8-1.8.7-.5 1.7-.8 2.8-.8.9 0 1.6.1 2.2.4a4.5 4.5 0 012.6 2.8c.3.7.4 1.4.4 2.2v8.3h-2v-7.8c0-1.3-.3-2.2-1-3-.6-.7-1.5-1-2.7-1-.6 0-1.1 0-1.6.2a3.7 3.7 0 00-2.2 2.2c-.2.5-.3 1.1-.3 1.7v7.7zm18.3-4.1a4.7 4.7 0 002.6 2.3c.5.2 1 .3 1.7.3a6 6 0 002.4-.5 11 11 0 001.8-1.4l1.2 1.1a6.6 6.6 0 01-5.5 2.6 6.7 6.7 0 01-4.7-2 6.8 6.8 0 01-1.5-2.2c-.4-.9-.5-1.8-.5-2.9a6.9 6.9 0 011.8-5 6.2 6.2 0 019.2 0 7 7 0 011.3 2.4c.2.8.4 1.7.4 2.7v.7H27c0 .7.3 1.3.5 1.9zm8.1-3.4l-.3-1.8c-.1-.6-.5-1-.9-1.4a4 4 0 00-3-1.4c-.6 0-1.2.1-1.7.4-.5.2-1 .5-1.3 1l-1 1.4-.4 1.8h8.6zm10.7-4.1c-.7.1-1.3.4-2 .7l-.5-1.7 2.2-.8c.8-.2 1.7-.3 2.7-.3a6 6 0 014.2 1.4c1 .9 1.5 2.2 1.5 4v8.2h-2v-2c-.4.6-1 1.2-1.8 1.6a6.6 6.6 0 01-4.8.5 5 5 0 01-1.6-.8 3.8 3.8 0 01-1.6-3.2 3.7 3.7 0 011.6-3.3 7.5 7.5 0 014.1-1.1 14.3 14.3 0 014.2.6v-.4c0-1.3-.4-2.2-1-2.8a5 5 0 00-3-1 8 8 0 00-2.2.4zm-.6 5.5c-.7.5-1 1.2-1 2 0 .5 0 .9.2 1.2.2.3.4.6.8.8.3.3.6.4 1 .6l1.3.1c.6 0 1.2 0 1.8-.2l1.4-.8 1-1.1.3-1.5v-1.3a21 21 0 00-4-.6c-1.2 0-2.2.3-2.8.8zm17.5 6.1h-2v-13.5h2v3.5a7.2 7.2 0 012.1-2.7 5.3 5.3 0 013.4-1v2.1h-.2c-.7 0-1.4.2-2 .4s-1.3.7-1.8 1.2-.8 1.1-1.1 2c-.3.7-.4 1.6-.4 2.6v5.3zm14.1-3.9c0 .9.2 1.4.6 1.8s1 .5 1.7.5a4.3 4.3 0 002-.5v1.7l-1.2.4a5.5 5.5 0 01-2.8 0 3 3 0 01-2-1.8c-.2-.6-.3-1.1-.3-1.8v-8.1h-1.9v-1.8h2v-4h2v4h4.2v1.8h-4.3v7.8zM109 242v-2.8l-1 1.2-1 1-1.4.6-1.7.2a6.2 6.2 0 01-4.5-1.8 7.6 7.6 0 01-2-5.2c0-1 .2-2 .6-3a6.7 6.7 0 013.5-3.5 6 6 0 017.5 2.4V223h2v19h-2zm-.3-9a5 5 0 00-4.5-3c-.6 0-1.2.1-1.8.4l-1.5 1c-.5.4-.8 1-1 1.6a6 6 0 00-.4 2.2c0 .8.1 1.5.4 2.2a5 5 0 001 1.6 4.4 4.4 0 003.3 1.4c.7 0 1.3-.1 1.8-.4l1.6-1c.5-.5.8-1 1-1.7.4-.6.5-1.3.5-2 0-.9-.1-1.6-.4-2.2zm9.2-7.4v-2.2h2.3v2.2h-2.3zm.1 16.3v-13.4h2v13.4h-2zm17.8-2a4 4 0 01-1 1.2c-.4.4-1 .6-1.5.8a6 6 0 01-2 .3 9.1 9.1 0 01-5.6-2l1.1-1.4a9 9 0 002.3 1.3c.8.3 1.6.4 2.4.4.8 0 1.5-.2 2-.6.5-.3.8-.9.8-1.5 0-.4-.1-.7-.3-1l-.7-.6a24.8 24.8 0 00-4-1.4c-.5-.1-1-.4-1.4-.6a3 3 0 01-1.4-2.6 3.6 3.6 0 011.3-2.9l1.4-.8a6 6 0 011.8-.2 9.5 9.5 0 014.8 1.5l-.8 1.5a9 9 0 00-2-1 7 7 0 00-2-.3 3 3 0 00-1.9.5c-.5.4-.7.8-.7 1.4 0 .4 0 .6.3.9l.8.6 1 .5 1.4.4 1.5.5 1.4.7 1 1c.2.5.4 1 .4 1.6 0 .7-.2 1.3-.4 1.8zm8.2-2a4.7 4.7 0 002.4 2.3 5.4 5.4 0 004.1-.2c.7-.4 1.3-.8 1.9-1.4l1.2 1.1a6.6 6.6 0 01-5.5 2.6 6.7 6.7 0 01-4.8-2 6.8 6.8 0 01-1.4-2.2c-.4-.9-.5-1.8-.5-2.9a6.9 6.9 0 011.8-5 6.2 6.2 0 019.2 0 7 7 0 011.3 2.4c.2.8.4 1.7.4 2.7v.7h-10.7c0 .7.2 1.3.5 1.9zm8-3.4c0-.6-.2-1.2-.4-1.8a4.2 4.2 0 00-2-2.4 4 4 0 00-1.9-.4c-.5 0-1 .1-1.6.4-.5.2-1 .5-1.3 1l-1 1.4-.4 1.8h8.6zm10.7-4.1c-.7.1-1.3.4-2 .7l-.5-1.7 2.2-.8c.8-.2 1.7-.3 2.7-.3a6 6 0 014.2 1.4c1 .9 1.5 2.2 1.5 4v8.2h-2v-2c-.4.6-1 1.2-1.8 1.6a6.6 6.6 0 01-4.8.5 5 5 0 01-1.6-.8 3.8 3.8 0 01-1.6-3.2 3.7 3.7 0 011.6-3.3 7.5 7.5 0 014.1-1.1 14.3 14.3 0 014.2.6v-.4c0-1.3-.4-2.2-1-2.8a5 5 0 00-3-1 8 8 0 00-2.2.4zm-.7 5.5c-.6.5-1 1.2-1 2 0 .5.1.9.3 1.2l.7.8 1.1.6 1.3.1c.6 0 1.2 0 1.8-.2l1.4-.8 1-1.1.3-1.5v-1.3a21 21 0 00-4-.6 5 5 0 00-2.9.8zm24.4 4a4 4 0 01-2.6 2c-.5.2-1.2.3-1.8.3a9.1 9.1 0 01-5.6-2l1-1.4a7.6 7.6 0 004.7 1.7c.8 0 1.4-.2 2-.6.5-.3.7-.9.7-1.5 0-.4 0-.7-.2-1l-.8-.6a24.8 24.8 0 00-4-1.4l-1.3-.6a3 3 0 01-1.5-2.6 3.6 3.6 0 011.3-2.9l1.5-.8a6 6 0 011.8-.2 9.5 9.5 0 014.8 1.5l-.8 1.5a9 9 0 00-2-1l-2-.3a3 3 0 00-2 .5c-.4.4-.6.8-.6 1.4 0 .4 0 .6.3.9l.7.6 1.1.5 1.3.4 1.6.5 1.4.7 1 1c.2.5.3 1 .3 1.6 0 .7 0 1.3-.3 1.8zm8.1-2a4.7 4.7 0 002.5 2.3 5.4 5.4 0 004.1-.2c.7-.4 1.3-.8 1.9-1.4l1.2 1.1a6.6 6.6 0 01-5.5 2.6 6.7 6.7 0 01-4.8-2 6.8 6.8 0 01-1.4-2.2 7.8 7.8 0 010-5.6c.2-.9.7-1.6 1.2-2.2a6.2 6.2 0 019.3 0c.5.6 1 1.4 1.2 2.3.3.8.4 1.7.4 2.7v.7H194c0 .7.2 1.3.5 1.9zm8-3.4c0-.6 0-1.2-.3-1.8l-.8-1.4a4 4 0 00-3-1.4 3 3 0 00-1.7.4c-.5.2-1 .5-1.3 1l-1 1.4-.4 1.8h8.6z"
          ></path>
          <path
            fill="#414142"
            d="M232.6 229.9a5.2 5.2 0 012.3-1.5l1.6-.2c1.6 0 2.8.5 3.7 1.5.9 1 1.3 2.2 1.3 4v8.2h-2v-7.8c0-1.3-.3-2.3-.9-3-.6-.7-1.5-1-2.6-1-.5 0-1 0-1.4.2l-1.2.8a4 4 0 00-.8 1.3 5 5 0 00-.3 1.8v7.7h-2V234c0-1.2-.3-2.2-.9-3-.6-.6-1.4-1-2.5-1a3.5 3.5 0 00-2.7 1.2l-.8 1.4c-.2.5-.2 1-.2 1.7v7.6h-2v-13.4h2v2.3l.7-1a4.6 4.6 0 013.6-1.6 4.5 4.5 0 014.3 2.7l.8-1zm17.5 8a4.7 4.7 0 002.5 2.3 5.4 5.4 0 004.1-.2c.6-.3 1.3-.8 1.9-1.4l1.2 1.1c-.7.8-1.4 1.4-2.3 1.9a8 8 0 01-3.2.7 6.7 6.7 0 01-4.8-2 7.4 7.4 0 01-2-5c0-1 .2-2 .5-2.8.3-.9.8-1.6 1.4-2.2a6.2 6.2 0 019.2 0c.6.6 1 1.4 1.2 2.3.3.8.5 1.7.5 2.7v.7h-10.7c0 .7.2 1.3.5 1.9zm8.1-3.4c0-.6-.2-1.2-.4-1.8s-.4-1-.8-1.4-.8-.8-1.3-1a4 4 0 00-1.8-.4c-.5 0-1 .1-1.6.4-.5.2-1 .5-1.3 1l-1 1.4a5 5 0 00-.4 1.8h8.6zm9.8 3.4a4.7 4.7 0 002.6 2.3 5.7 5.7 0 004.1-.2c.7-.3 1.3-.8 1.8-1.4l1.3 1.1c-.7.8-1.5 1.4-2.3 1.9a8 8 0 01-3.2.7 6.7 6.7 0 01-4.8-2 7.4 7.4 0 01-2-5c0-1 .2-2 .5-2.8a6.2 6.2 0 0110.6-2.2c.5.6 1 1.4 1.2 2.3.3.8.4 1.7.4 2.7v.7h-10.6c0 .7.2 1.3.5 1.9zm8.2-3.4c0-.6-.2-1.2-.4-1.8s-.5-1-.8-1.4-.8-.8-1.3-1a4 4 0 00-1.8-.4 3 3 0 00-1.6.4c-.5.2-1 .5-1.3 1l-1 1.4a5 5 0 00-.4 1.8h8.6zm10.4 3.6c0 .9.2 1.4.6 1.8s1 .5 1.7.5a4.3 4.3 0 002-.5v1.7l-1.2.4a5.5 5.5 0 01-2.8 0 3 3 0 01-2-1.8c-.2-.6-.3-1.1-.3-1.8v-8.1h-1.9v-1.8h2v-4h2v4h4.2v1.8h-4.3v7.8z"
          ></path>
          <path
            fill="none"
            stroke="#414142"
            strokeMiterlimit="10"
            d="M5.1 172.6h311.3"
          ></path>
        </symbol>
        <symbol
          viewBox="0 0 366.5 110.7"
          id="boehringer-ingelheim"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="currentColor"
            d="M23.9 97.2A54 54 0 018.5 82 53 53 0 1182 97.2v-31h5.2v21.2A49.4 49.4 0 00101 53 48.3 48.3 0 0053 4.5C26.3 4.5 4.9 26.2 4.9 53.3c0 12.4 4.4 23.3 13.6 34.1V66.2h5.4v31zm10.4 5.4a31 31 0 01-5.2-2.4v-34h5.2v36.4zm10.6 2.7l-2.7-.5-2.5-.6V31.8h5.2v73.5zm10.6.5l-2.1.1-3.1-.1v-74h5.2v74zm10.6-1.7c-1.7.6-3.1 1-5.2 1.4V31.8H66V104zm.1-76.2L53 17.6 39.8 28l-3-3.8L53 11.5 69 24l-2.9 3.8zm10.6 72.3l-5.3 2.5V66.2h5.3v34zm58.4-78v-14c1.6-.6 2.4-.7 3.5-.7 4 0 6.3 2.6 6.3 7.1 0 5.2-2.2 7.7-7 7.7h-2.8zm-2.5-16.8h-6.8v2.3l3.7.7v32.4l-3.7.7v2.2h6.4l4.5.1h3.4c3.7 0 5.7-.2 7.4-.9 3.7-1.4 6-5 6-9.2 0-5.5-3.1-9.2-8.9-10.4 4.6-2.2 6.7-5 6.7-9 0-5.6-4.3-9.3-10.6-9.3l-3.5.2-4.6.2zm2.5 19.6h2.5c6.4 0 9.4 2.5 9.4 8 0 5.2-3.2 8.5-8.4 8.5-1.6 0-2.4-.3-3.5-1V25zm34-9.2c-6.8 0-11.4 6-11.4 14.7 0 8.2 4.4 13.8 10.7 13.8 6.7 0 11.3-6 11.3-14.8 0-8.2-4.3-13.7-10.7-13.7zm-.3 2.7c3.1 0 4.9 3.7 4.9 10.4 0 8.3-1.8 12.6-5.1 12.6-3.2 0-5-4-5-11.2 0-7.4 2-11.8 5.2-11.8zm34.8 11.2c-.1-9.3-3.2-13.8-9.4-13.8-6.5 0-10.4 5.6-10.4 14.9 0 8.7 3.8 13.5 10.5 13.5 4.4 0 6.4-1.5 9.2-6.5l-2.5-1c-1.7 2.6-3.1 3.6-5.1 3.6-4 0-6-3.2-6.5-10.7h14.2zM189.5 27c.7-5.8 2-8.4 4.6-8.4 2.5 0 3.7 2.4 3.9 8.4h-8.5zm-50.7 73.7v-2.4l-3.2-.6V65.2l3.3-.7v-2.3h-12.8v2.5l3.5.5v32.6l-3.5.6v2.3h12.7zm29 0v-2.4l-3-.6V80.4c0-4.6-2.3-7.3-6.5-7.3-2.5 0-4 .7-7.4 3.3V73h-1.5l-7 1.8V77l3.3.5v20.3l-3.2.6v2.3h11.4v-2.4l-2.9-.7V79.5c2.2-1.8 3.6-2.5 5.3-2.5 2.1 0 3.1 1.5 3.1 4.6v16.3l-2.9.5v2.3h11.3zm26-23.9v-3.2h-5.5l-1 .2c-.6 0-1.4-.1-2.5-.4-2-.5-2.4-.6-3.5-.6A9 9 0 00172 82c0 3.5 1.2 5.6 4.6 7.7-3.6 2.3-5 4-5 6 0 1.6.9 2.6 3 3.5-3.2 2.1-4.3 3.6-4.3 5.8 0 3.5 4 5.7 10 5.7 8 0 13.2-3.8 13.2-9.7 0-4.1-2.4-6.1-7.7-6.4l-6.7-.3c-1.6-.1-2.3-.4-2.3-1.1s.8-1.6 2.1-2.5a9 9 0 003 .5c5.4 0 9.4-3.8 9.4-9 0-2-.5-3.4-2-5.4h4.6zm-12.3-1.7c2.7 0 4 2.4 4 7.3 0 4.1-1.2 6.2-3.8 6.2-2.7 0-3.8-2.1-3.8-6.8 0-4.5 1.1-6.7 3.6-6.7zm-1.7 24.7c8.6.5 9.8 1 9.8 3.3 0 2.7-3.4 4.6-8 4.6-3.7 0-6-1.5-6-4 0-1.6.6-2.7 2-4h2.2zm22.6-15.9c.7-5.9 2.2-8.3 4.7-8.3 2.6 0 3.7 2.5 3.8 8.3h-8.5zM232 43.7v-2.3l-3-.6V24c0-5-2.1-7.6-6.5-7.6-2.3 0-4.1.8-7.2 3.2V2.8h-1.6l-7 1.4v2l3.2.6v34l-3.3.7v2.2h11.3v-2.3l-2.6-.6v-18c2.2-1.8 3.4-2.4 5-2.4 2.4 0 3.3 1.5 3.3 5.5v15l-2.7.6v2.2h11zm12-27.5h-1.6l-6.7 1.7v1.8l3.2.6v20.5l-3.2.7v2.2H248v-2.3l-3.9-.6V26.2c0-1.6 1.6-3.7 3.5-4.7l2.9 1.6c1.4-1.1 2.1-2.1 2.1-3.4 0-2-1.2-3.2-3.2-3.2s-3.1 1-5.4 4.8v-5.1zm16.6-13.4c-2 0-3.5 1.5-3.5 3.6 0 2 1.5 3.5 3.5 3.5s3.6-1.5 3.6-3.5-1.6-3.6-3.6-3.6zm6.3 40.9v-2.3l-3.1-.6V16.4h-1.4l-7 1.8V20l3 .6v20.1l-3 .7v2.2H267zm-50.3 42.8c-.2-3.7-.3-5.5-.8-7-1.3-4.3-4.2-6.6-8.7-6.6-6.4 0-10.3 5.5-10.3 14.7 0 8.6 3.8 13.6 10.4 13.6 4.4 0 6.7-1.7 9.3-6.4l-2.5-1c-1.6 2.5-3 3.5-5.2 3.5-4 0-5.9-3.1-6.5-10.8h14.3zm14.8 14.2v-2.4l-3-.6v-38H227l-7 1.5v1.9l3 .3v34.4l-3.2.6v2.3h11.6zm29.1 0v-2.4l-3-.6V80.5c0-4.6-2.3-7.1-6.4-7.1-2.6 0-4.4.7-7.4 3.2v-17h-1.5l-7 1.6v1.9l3.1.6v34l-3.2.7v2.3h11.3v-2.4l-2.7-.6V79.8c2.2-1.9 3.6-2.5 5.1-2.5 2.4 0 3.3 1.4 3.3 5.4V98l-2.7.5v2.3h11.1zM284 86.5c-.2-3.7-.3-5.5-.7-7-1.4-4.3-4.3-6.6-8.7-6.6-6.5 0-10.4 5.5-10.4 14.7 0 8.6 3.8 13.6 10.5 13.6 4.3 0 6.7-1.7 9.2-6.4l-2.4-1c-1.7 2.5-3.1 3.5-5.3 3.5-4 0-5.9-3.1-6.4-10.8H284zm-14.2-2.6c.6-5.9 2-8.3 4.6-8.3 2.6 0 3.7 2.5 3.8 8.3h-8.4zm40-65.7c2.7 0 4 2.3 4 7.2 0 4.1-1.2 6.3-3.8 6.3-2.7 0-3.8-2.2-3.8-6.8s1.1-6.7 3.6-6.7zm-13.6 25.5v-2.3l-3-.7V23.4c0-4.6-2.3-7.2-6.5-7.2-2.4 0-4 .6-7.3 3.2v-3.3h-1.6l-7 1.7v2.3l3.3.4v20.3l-3.2.7v2.2h11.5v-2.3l-3-.7V22.5c2.2-1.8 3.6-2.4 5.3-2.4 2.1 0 3.1 1.4 3.1 4.5V41l-2.9.6v2.2h11.3zm26-23.9v-3.2l-4.6.1h-1l-1 .1c-.6 0-1.4 0-2.5-.4-2-.5-2.4-.6-3.5-.6a9 9 0 00-9.3 9.3c0 3.4 1.2 5.6 4.6 7.7-3.6 2.2-5 4-5 5.9 0 1.5.9 2.7 3 3.5-3 2-4.3 3.6-4.3 5.8 0 3.5 4 5.7 10 5.7 8 0 13.2-3.8 13.2-9.7 0-4-2.4-6.1-7.7-6.3l-6.7-.4c-1.6 0-2.3-.4-2.3-1.2 0-.5.8-1.4 2.1-2.3a9 9 0 003 .4c5.4 0 9.4-3.8 9.4-8.9 0-2.1-.4-3.5-2-5.5h4.6zM306 42.7c11 .7 12 .9 12 3.4 0 2.6-3.5 4.6-8.1 4.6-3.7 0-6-1.4-6-3.9 0-1.7.6-2.8 2.1-4.1zm39-13c-.1-9.3-3.1-13.8-9.3-13.8-6.5 0-10.4 5.6-10.4 14.9 0 8.7 3.8 13.5 10.5 13.5 4.3 0 6.3-1.5 9.1-6.5l-2.4-1c-1.7 2.6-3.2 3.6-5.2 3.6-4 0-5.9-3.2-6.4-10.7H345zM331 27c.6-5.8 2-8.4 4.5-8.4 2.6 0 3.7 2.4 4 8.4H331zm27-10.8h-1.6l-6.7 1.7v1.8l3.2.6v20.5l-3.2.7v2.2H362v-2.3l-4-.6V26.2c0-1.6 1.6-3.7 3.5-4.7l3 1.6c1.4-1.1 2-2.1 2-3.4 0-2-1.2-3.2-3.2-3.2s-3.1 1-5.4 4.8v-5.1zm-64 43.4a3.7 3.7 0 00-3.8 3.7c0 2 1.5 3.6 3.5 3.6s3.7-1.7 3.7-3.7c0-1.9-1.6-3.6-3.5-3.6zm6 41v-2.3l-3.2-.6V73.4h-1.3l-7 1.7V77l3 .7v20.2l-3 .6v2.3H300zm43.7 0v-2.3l-3.2-.6V81.3c0-5.6-2-8-6.8-8-2.9 0-4.7 1-7.6 3.7-1.6-2.4-3.5-3.5-6.3-3.5-2.7 0-4.8.9-7.6 3.2V73h-1.4l-7 1.8v1.9l3.2.6v20.5l-3.2.6v2.3H315v-2.4l-2.5-.6v-18c1.9-1.9 3.2-2.6 5-2.6 2.4 0 3.6 1.6 3.6 5v15.7l-3.2.6v2.3h11.3v-2.4l-2.8-.6V79.8c2.2-2 3.5-2.7 5.2-2.7 2.4 0 3.4 1.5 3.4 5.2v15.5l-3 .6v2.3h11.6z"
          ></path>
        </symbol>

        <symbol
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          id="close-btn"
        >
          <path fill="#FFFFFF" d="M0 0h24v24H0V0z" opacity=".87" />
          <path
            fill="#FFFFFF"
            d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z"
          />
        </symbol>
      </svg>
      {/* ======== PRINTABLE =========== */}
      {showPopup && (
        <div
          id="element-to-print"
          className="bg-blue-500 text-white relative"
          style={{
            fontSize: ".9rem",
            width: "1000px",
            height: "518px",
            backgroundImage: `url('${bg_voucher}')`,
          }}
        >
          <p
            className="text-red-ci absolute"
            style={{ right: "55px", top: "30px" }}
          >
            {`Serial No.: ${currentSerial?.toString().padStart(4, "0")}`}
          </p>
          <p
            className="text-black absolute flex flex-col justify-between "
            style={{
              left: "40px",
              top: "305px",
              height: "120px",
              maxWidth: "240px",
              lineHeight: "1rem",
            }}
          >
            <span className="font-bold uppercase">{selected?.name}</span>
            <span>{selected?.address.replaceAll("-", "/")}</span>
            <span>{selected?.phone}</span>
          </p>
        </div>
      )}
    </div>
  );
}
